module.exports = {
	"getSNatRules": "/api/cps/nat/describeSNatRules", // 查询SNAT规则列表
	"getDNatRules": "/api/cps/nat/describeDNatRules", // 查询DNAT规则列表
	"getNatPrivateIps": "/api/cps/nat/describeNatPrivateIps", // NAT规则的内网Ip列表
	"getNatEips": "/api/cps/nat/describeNatEIps", // NAT规则中的可用的EIP列表
	"createSNatRules": "/api/cps/nat/createSNatRules", // 添加SNAT规则
	"deleteSNatRule": "/api/cps/nat/deleteSNatRule", // 删除SNAT规则
	"modifySNatRules": "/api/cps/nat/modifySNatRules", // 修改SNAT规则
	"createDNatRule": "/api/cps/nat/createDNatRule", // 添加DNAT规则
	"deleteDNatRule": "/api/cps/nat/deleteDNatRule", // 删除DNAT规则
	"modifyDNatRule": "/api/cps/nat/modifyDNatRule", // 修改DNAT规则
	"describeNatCountByIp": "/api/cps/nat/describeNatCountByIp", // 根据公网Ip查询绑定的snat和dnat规则数量
};



// WEBPACK FOOTER //
// ./src/api/nat/detail/config.js